import { render, staticRenderFns } from "./grade.vue?vue&type=template&id=2bb374de&scoped=true&"
import script from "./grade.vue?vue&type=script&lang=js&"
export * from "./grade.vue?vue&type=script&lang=js&"
import style0 from "./grade.vue?vue&type=style&index=0&id=2bb374de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb374de",
  null
  
)

export default component.exports